import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, Link } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AuthCallback from './components/AuthCallback';
import WebViewComplete from './pages/auth/WebViewComplete';
import AuthFinish from './pages/auth/AuthFinish';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Wallet from './pages/Wallet';
import Withdraw from './pages/Withdraw';
import Transfer from './pages/Transfer';
import Profile from './pages/Profile';
import Store from './pages/Store';
import Coupons from './pages/Coupons';
import CouponConfirmation from './pages/CouponConfirmation';
import Songs from './pages/Songs';
import SongPage from './pages/SongPage';
import Stories from './pages/Stories';
import Story from './pages/Story';
import WhatsApp from './pages/WhatsApp';
import TeacherChat from './pages/TeacherChat';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Landing from './pages/Landing';
import AI from './pages/AI';
import LeaderboardPage from './pages/Leaderboard';
import ChallengeMode from './pages/ChallengeMode';
// Practice Mode Pages
import PracticeHub from './pages/practice/PracticeHub';
import SongPractice from './pages/practice/SongPractice';
import PracticeChat from './pages/PracticeChat';
import PrivateChat from './pages/PrivateChat';
import Learners from './pages/Learners';
import Friends from './pages/Friends';
import Messages from './pages/Messages';

// Admin Pages
import Reports from './pages/admin/Reports';
import CommunityGuidelines from './pages/CommunityGuidelines';
import ReportPage from './pages/ReportPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Header from './components/Header';
import PushNotificationPrompt from './components/PushNotificationPrompt';

function AppContent() {
  const location = useLocation();
  const user = localStorage.getItem('user');

  const shouldShowHeader =
    location.pathname !== '/' &&
    location.pathname !== '/teacher-chat' &&
    location.pathname !== '/private-chat' &&
    location.pathname !== '/messages';

  return (
    <>
      {/* Show header on all pages except Landing and chat-focused pages */}
      {shouldShowHeader && <Header />}

      <main className={shouldShowHeader ? 'pt-12' : ''}>
        <Routes>
          {/* Landing page as root, redirect to dashboard if authenticated */}
          <Route
            path="/"
            element={user ? <Navigate to="/dashboard" replace /> : <Landing />}
          />

          {/* Public routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/webview-complete" element={<WebViewComplete />} />
          <Route path="/auth/finish" element={<AuthFinish />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/community-guidelines" element={<CommunityGuidelines />} />
          <Route path="/report" element={<ReportPage />} />

          <Route path="/whatsapp" element={<WhatsApp />} />
          <Route path="/ai" element={<AI />} />
          <Route path="/teacher-chat" element={<TeacherChat />} />

          {/* Learners and Private Chat routes */}
          <Route
            path="/learners"
            element={
              <ProtectedRoute>
                <Learners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/private-chat"
            element={
              <ProtectedRoute>
                <PrivateChat />
              </ProtectedRoute>
            }
          />

          <Route
            path="/friends"
            element={
              <ProtectedRoute>
                <Friends />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            }
          />

          {/* Admin routes */}
          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallet"
            element={
              <ProtectedRoute>
                <Wallet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/withdraw"
            element={
              <ProtectedRoute>
                <Withdraw />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transfer"
            element={
              <ProtectedRoute>
                <Transfer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store"
            element={
              <ProtectedRoute>
                <Store />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coupons"
            element={
              <ProtectedRoute>
                <Coupons />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coupon-confirmation"
            element={
              <ProtectedRoute>
                <CouponConfirmation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/songs"
            element={
              <ProtectedRoute>
                <Songs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/songs/:id"
            element={
              <ProtectedRoute>
                <SongPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stories"
            element={
              <ProtectedRoute>
                <Stories />
              </ProtectedRoute>
            }
          />
          <Route
            path="/story/:id"
            element={
              <ProtectedRoute>
                <Story />
              </ProtectedRoute>
            }
          />

          {/* Practice Mode Routes */}
          <Route
            path="/practice"
            element={
              <ProtectedRoute>
                <PracticeHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/practice/song/:id"
            element={
              <ProtectedRoute>
                <SongPractice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/practice-chat"
            element={
              <ProtectedRoute>
                <PracticeChat />
              </ProtectedRoute>
            }
          />

           <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          

          {/* Leaderboard Route */}
          <Route
            path="/leaderboard"
            element={
              <ProtectedRoute>
                <LeaderboardPage />
              </ProtectedRoute>
            }
          />

               {/* Challenge Mode Route */}
          <Route
            path="/challenge"
            element={
              <ProtectedRoute>
                <ChallengeMode />
              </ProtectedRoute>
            }
          />


          {/* Catch-all Redirect */}
          <Route
            path="*"
            element={user ? <Navigate to="/dashboard" replace /> : <Navigate to="/" replace />}
          />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <AppContent />
      <PushNotificationPrompt />
    </Router>
  );
}

export default App;
